import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { ICurrencyFilterOption } from '../../models/i-currency-filter-option.interface';
import { IState } from '../../models/reducers/i-state.interface';

import { useRMVCurrency } from '../../hooks/useCurrency';

import { getIconByCurrencySymbol } from '../../utils/get-currency-icon-by-symbol';

import styles from './CurrencySelect.module.scss';

const currencyValueRenderer = (option: ICurrencyFilterOption | null) =>
  option ? (
    <div className={styles['currency-option']}>
      <img src={option.icon} alt="" />
      <span>{option.label}</span>
    </div>
  ) : (
    <div>Currency</div>
  );

interface ICurrencySelectProps {
  className?: string;
  value?: ICurrencyFilterOption;
  placeholder?: string;
  label?: string;
  disabled?: boolean;
  clearable?: boolean;
  onChange: (option: ICurrencyFilterOption) => void;
}

const CurrencySelect = ({
  value,
  label,
  disabled,
  clearable = false,
  placeholder = 'Currency',
  className = '',
  onChange,
}: ICurrencySelectProps) => {
  const rmvCurrency = useRMVCurrency();
  const currencies = useSelector((state: IState) => state.wallet.currencies);
  const [currencyOptions, setCurrencyOptions] = useState<ICurrencyFilterOption[]>([]);

  useEffect(() => {
    if (!currencies) {
      return;
    }

    setCurrencyOptions(
      currencies.map((currency) => ({
        icon: getIconByCurrencySymbol(currency.symbol),
        value: currency.id,
        label: currency.symbol,
      }))
    );
  }, [currencies]);

  return (
    <div className={styles['currency']}>
      {label && <p>{label}</p>}
      <div>
        <img src={rmvCurrency?.icon} alt="rmv icon" />
        <span>RMV</span>
      </div>
    </div>
    // <SingleSelect
    //   label={label}
    //   placeholder={placeholder}
    //   className={className}
    //   value={value}
    //   options={currencyOptions}
    //   disabled={disabled}
    //   clearable={clearable}
    //   onChange={(option) => onChange(option as ICurrencyFilterOption)}
    //   formatOptionLabel={(option: ISelectOption | undefined) => currencyValueRenderer(option as ICurrencyFilterOption)}
    // />
  );
};

export default CurrencySelect;
